import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pbg-scattergories-rules',
  templateUrl: './scattergories-rules.component.html',
  styleUrls: ['./scattergories-rules.component.scss']
})
export class ScattergoriesRulesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
